import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, formatDate } from "@/components/pcp";
import { ArrowClockwise, TrashSimple, Warning } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Lixeira() {
  const [data, setData] = useState({ ordens: [], contratos: [] });
  const [resetLoading, setResetLoading] = useState(false);
  const load = () => api.get("/lixeira").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);

  const restaurar = async (tipo, id) => {
    await api.post(`/lixeira/restaurar/${tipo}/${id}`);
    toast.success("Restaurado");
    load();
  };
  const excluir = async (tipo, id) => {
    if (!window.confirm("Excluir permanentemente? Essa ação não pode ser desfeita.")) return;
    await api.delete(`/lixeira/${tipo}/${id}`);
    toast.success("Excluído permanentemente");
    load();
  };

  const resetTudo = async () => {
    const confirmacao = window.prompt(
      "⚠️  ATENÇÃO — RESET TOTAL DO SISTEMA\n\n" +
      "Isso apagará PERMANENTEMENTE:\n" +
      "• Todas as Ordens de Serviço\n" +
      "• Todos os Itens de Serviço\n" +
      "• Todos os Apontamentos\n" +
      "• Todos os Contratos\n" +
      "• Todas as Equipes\n" +
      "• Toda a Programação Semanal\n" +
      "• Todas as Não Conformidades\n" +
      "• Todos os movimentos de estoque\n\n" +
      "Mantém: usuários, insumos e composições padrão.\n\n" +
      "Para confirmar, digite: RESETAR"
    );
    if (confirmacao !== "RESETAR") {
      toast.error("Reset cancelado");
      return;
    }
    setResetLoading(true);
    try {
      const { data: r } = await api.post("/admin/reset?confirmar=RESETAR-TUDO");
      const total = Object.values(r.apagados || {}).reduce((s, n) => s + n, 0);
      toast.success(`Reset executado! ${total} registros apagados. Próxima OS será 2026-0001.`);
      setTimeout(() => window.location.reload(), 1500);
    } catch (e) {
      toast.error("Erro ao resetar. Verifique se você é admin.");
    } finally {
      setResetLoading(false);
    }
  };

  return (
    <>
      <PageHeader
        testid="page-lixeira"
        title="Lixeira e Administração"
        subtitle="Itens excluídos permanecem aqui por 30 dias · Reset total disponível para admin"
        actions={
          <button
            className="btn btn-danger"
            onClick={resetTudo}
            disabled={resetLoading}
            data-testid="btn-reset-tudo"
          >
            <Warning size={16} weight="bold" /> {resetLoading ? "Resetando…" : "Reset total do sistema"}
          </button>
        }
      />
      <div className="page-body">
        <div style={{ padding: 16, background: "#FEE2E2", border: "1px solid #FCA5A5", borderRadius: 3, marginBottom: 24, display: "flex", alignItems: "center", gap: 12 }}>
          <Warning size={20} weight="bold" color="#B91C1C" />
          <div style={{ fontSize: "0.85rem", color: "#7F1D1D" }}>
            <strong>Reset total</strong> apaga permanentemente todas as OS, itens, apontamentos, contratos, equipes, programação e movimentos de estoque.
            Mantém apenas usuários, insumos e composições padrão. Use apenas para começar do zero. <strong>Ação irreversível.</strong>
          </div>
        </div>
        <div className="pcp-card" style={{ padding: 20, marginBottom: 24 }}>
          <h2 className="font-display font-bold text-lg mb-3">Ordens de Serviço ({data.ordens.length})</h2>
          {data.ordens.length === 0 ? <div style={{ color: "#71717A" }}>Nenhuma OS na lixeira.</div> : (
            <table className="pcp-table">
              <thead><tr><th>OS</th><th>Contratante</th><th>Excluída em</th><th>Por</th><th></th></tr></thead>
              <tbody>{data.ordens.map((o) => (
                <tr key={o.id}>
                  <td className="font-mono">{o.numero}</td>
                  <td>{o.contratante}</td>
                  <td className="font-mono text-xs">{formatDate(o.deleted_at)}</td>
                  <td>{o.deleted_by}</td>
                  <td style={{ textAlign: "right" }}>
                    <button className="btn btn-outline btn-sm" onClick={() => restaurar("ordens", o.id)}><ArrowClockwise size={14} weight="bold" /> Restaurar</button>
                    <button className="btn btn-danger btn-sm" onClick={() => excluir("ordens", o.id)}><TrashSimple size={14} weight="bold" /> Excluir</button>
                  </td>
                </tr>
              ))}</tbody>
            </table>
          )}
        </div>

        <div className="pcp-card" style={{ padding: 20 }}>
          <h2 className="font-display font-bold text-lg mb-3">Contratos ({data.contratos.length})</h2>
          {data.contratos.length === 0 ? <div style={{ color: "#71717A" }}>Nenhum contrato na lixeira.</div> : (
            <table className="pcp-table">
              <thead><tr><th>Número</th><th>Contratante</th><th>Excluído em</th><th></th></tr></thead>
              <tbody>{data.contratos.map((c) => (
                <tr key={c.id}>
                  <td className="font-mono">{c.numero}</td>
                  <td>{c.contratante}</td>
                  <td className="font-mono text-xs">{formatDate(c.deleted_at)}</td>
                  <td style={{ textAlign: "right" }}>
                    <button className="btn btn-outline btn-sm" onClick={() => restaurar("contratos", c.id)}><ArrowClockwise size={14} weight="bold" /> Restaurar</button>
                    <button className="btn btn-danger btn-sm" onClick={() => excluir("contratos", c.id)}><TrashSimple size={14} weight="bold" /> Excluir</button>
                  </td>
                </tr>
              ))}</tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
